import React from 'react'
import { convertTimeTo12HourFormat, empty, getInputDateFormat } from '../../../Utilities/utils'

import './ActivitiesList.css';
import colors from '../../../config/colors';
import { NavLink } from 'react-router-dom';

function ActivitiesList({ data, link }) {
  return (
    <NavLink to={link} style={{ textDecoration: 'none', color: colors.black }}>
      <div className="activity-list-box">
        <div className="activity-list-container">
          <div className="activity-list-icon">
            <div className="activity-list-icon-box" style={{ color: data?.activityTypeIconColor || '#000000' }}>
              <i className={data?.activityTypeIcon}></i>
            </div>
          </div>

          <div className="activity-list-body">
            <div className="title">{ data?.title }</div>
            <div className="type-title mt-5">
              <span>{data?.activityTypeTitle} </span>
              <span>&nbsp;&nbsp;&nbsp;<i className='fa fa-tag' style={{ color: colors.gray }}></i> {data?.activityTypeNature}</span></div>
            <div className="duration mt-5">
              <i className='fa fa-calendar' style={{ color: colors.gray }}></i>&nbsp;&nbsp;&nbsp;{!empty(data?.startDate) ? getInputDateFormat(new Date(data.startDate)) : ''} to {!empty(data?.endDate) ? getInputDateFormat(new Date(data.endDate)) : ''}
            </div>
            <div className="duration mt-2">
              <i className='fa fa-clock' style={{ color: colors.gray }}></i>&nbsp;&nbsp;&nbsp;{!empty(data?.startTime) ? convertTimeTo12HourFormat(data.startTime) : ''} to {!empty(data.endTime) ? convertTimeTo12HourFormat(data?.endTime) : ''}</div>
          </div>
        </div>
      </div>
    </NavLink>
  )
}

export default ActivitiesList